export default __webpack_public_path__ + "static/media/confirmImage.b5c15b1c.png";